(function () {
  // Client-side cart cache. Populated on first load and kept in sync with every
  // mutation response so add/remove only need a single network round trip.
  let cartCache = null;

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    });
  }

  function getCart(force) {
    if (cartCache && !force) return Promise.resolve(cartCache);
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { cartCache = cart; return cart; });
  }

  function setCart(cart) {
    cartCache = cart;
    return cart;
  }

  function showOverlay() {
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'block';
  }

  function hideOverlay() {
    const overlay = document.getElementById('overlay');
    if (overlay) overlay.style.display = 'none';
  }

  function showRowMessage(row, message, isError) {
    const el = row.querySelector('.success-message');
    if (!el) return;
    el.textContent = message;
    el.style.color = isError ? '#a94442' : '#155724';
    el.style.background = isError ? '#f2dede' : '#d4edda';
    el.style.borderColor = isError ? '#ebccd1' : '#c3e6cb';
    el.style.display = 'block';
    clearTimeout(el._hideTimer);
    el._hideTimer = setTimeout(function () { el.style.display = 'none'; }, 2500);
  }

  function updateCartSummary(cart) {
    function apply(cart) {
      const bubble = document.querySelector('.cart-count-bubble');
      if (bubble) bubble.textContent = cart.item_count;

      const countEl = document.querySelector('.total_products_count');
      if (countEl) countEl.textContent = cart.item_count;

      const popupCountEl = document.querySelector('.total_products_count_popup');
      if (popupCountEl) popupCountEl.textContent = cart.item_count;

      const subtotalEl = document.querySelector('.sub_total');
      if (subtotalEl) subtotalEl.textContent = (cart.items_subtotal_price / 100).toFixed(2);
    }

    if (cart) {
      apply(cart);
      return Promise.resolve(cart);
    }
    return getCart().then(apply);
  }

  function getRowQuantity(row) {
    const input = row.querySelector('input[name="quantity"]');
    let quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity <= 0) {
      quantity = 1;
      input.value = 1;
    }
    return quantity;
  }

  function getRowVariantId(row) {
    const select = row.querySelector('select[name="variant"]');
    if (select) return parseInt(select.value, 10);
    const hidden = row.querySelector('input[name="variant"]');
    return parseInt(hidden ? hidden.value : row.dataset.variantId, 10);
  }

  function updateRowTotal(row) {
    const quantityInput = row.querySelector('input[name="quantity"]');
    const totalPriceEl = row.querySelector('.total-price');
    const priceSource = row.querySelector('.quantity-selector');
    if (!quantityInput || !totalPriceEl || !priceSource) return;

    const unitPriceCents = parseFloat(priceSource.dataset.unitPrice);
    const quantity = parseInt(quantityInput.value, 10) || 1;
    totalPriceEl.textContent = 'Total: ' + formatMoney(unitPriceCents * quantity);
  }

  // Re-syncs every product row against the live cart: selects the variant
  // actually in the cart (not just the first option), reveals the Remove
  // button, and restores the saved quantity.
  function syncRowsWithCart(cart) {
    document.querySelectorAll('.product-row').forEach(function (row) {
      const variantSelect = row.querySelector('select[name="variant"]');
      let matchedItem = null;

      if (variantSelect) {
        const optionIds = Array.prototype.map.call(variantSelect.options, function (o) {
          return parseInt(o.value, 10);
        });
        matchedItem = cart.items.find(function (item) {
          return optionIds.indexOf(item.variant_id) !== -1;
        });
        if (matchedItem) {
          variantSelect.value = matchedItem.variant_id;
          row.dataset.variantId = matchedItem.variant_id;
        }
      } else {
        matchedItem = cart.items.find(function (item) {
          return item.variant_id === parseInt(row.dataset.variantId, 10);
        });
      }

      const removeBtn = row.querySelector('.remove-from-cart-btn');
      const quantityInput = row.querySelector('input[name="quantity"]');

      if (matchedItem) {
        if (removeBtn) removeBtn.style.display = 'inline-block';
        if (quantityInput) quantityInput.value = matchedItem.quantity;
      }

      updateRowTotal(row);
    });
  }

  function initImageModal() {
    const modal = document.getElementById('image-modal');
    const modalImg = document.getElementById('modal-full-image');
    if (!modal || !modalImg) return;

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.open-image-modal');
      if (trigger) {
        modal.style.display = 'block';
        modalImg.src = trigger.getAttribute('data-full');
        return;
      }
      if (e.target.closest('.close-modal') || e.target === modal) {
        modal.style.display = 'none';
        modalImg.src = '';
      }
    });
  }

  function initVariantSelect() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('select[name="variant"]')) return;
      const row = e.target.closest('.product-row');
      if (!row) return;
      row.dataset.variantId = e.target.value;
      updateRowTotal(row);
    });
  }

  function initQuantityButtons() {
    document.addEventListener('click', function (e) {
      const minusBtn = e.target.closest('.qty-btn.minus');
      const plusBtn = e.target.closest('.qty-btn.plus');
      if (!minusBtn && !plusBtn) return;

      const row = e.target.closest('.product-row');
      if (!row) return;
      const qtyInput = row.querySelector('input[name="quantity"]');
      const current = parseInt(qtyInput.value, 10) || 1;

      if (minusBtn && current > 1) qtyInput.value = current - 1;
      if (plusBtn) qtyInput.value = current + 1;

      updateRowTotal(row);
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('.product-row input[name="quantity"]')) return;
      const value = parseInt(e.target.value, 10);
      e.target.value = (!value || value < 1) ? 1 : value;
      updateRowTotal(e.target.closest('.product-row'));
    });
  }

  function initAddToCart() {
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.add-to-cart-btn');
      if (!button) return;

      const row = button.closest('.product-row');
      const variantId = getRowVariantId(row);
      const quantity = getRowQuantity(row);
      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Adding to cart...';

      getCart()
        .then(function (cart) {
          const existingItem = cart.items.find(function (item) { return item.variant_id === variantId; });

          if (existingItem) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: existingItem.key, quantity: quantity })
            }).then(function (res) { return res.json(); });
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity })
          })
            .then(function (res) { return res.json(); })
            .then(function () { return getCart(true); });
        })
        .then(function (cart) {
          setCart(cart);
          button.textContent = 'Added!';
          const removeBtn = row.querySelector('.remove-from-cart-btn');
          if (removeBtn) removeBtn.style.display = 'inline-block';
          updateCartSummary(cart);
          showRowMessage(row, 'Added to cart!');
        })
        .catch(function (err) {
          console.error(err);
          showRowMessage(row, 'Could not update cart. Please try again.', true);
        })
        .finally(function () {
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1200);
        });
    });
  }

  function initRemoveFromCart() {
    document.addEventListener('click', function (e) {
      const button = e.target.closest('.remove-from-cart-btn');
      if (!button) return;

      const row = button.closest('.product-row');
      const variantId = getRowVariantId(row);
      button.disabled = true;

      getCart()
        .then(function (cart) {
          const item = cart.items.find(function (i) { return i.variant_id === variantId; });
          if (!item) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          setCart(cart);
          button.style.display = 'none';
          updateCartSummary(cart);
          showRowMessage(row, 'Removed from cart.');
        })
        .catch(function (err) { console.error(err); })
        .finally(function () { button.disabled = false; });
    });
  }

  function renderCartRow(item, index) {
    const line = index + 1;
    const showCompare = item.original_line_price > item.line_price;
    return (
      '<div class="cart-modal__item" data-line="' + line + '">' +
        '<img class="cart-modal__item-image" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' +
        '<div class="cart-modal__item-info">' +
          '<p class="cart-modal__item-title">' + item.product_title + '</p>' +
          '<div class="cart-modal__item-price">' +
            (showCompare ? '<s>' + formatMoney(item.original_price) + '</s>' : '') +
            formatMoney(item.price) +
          '</div>' +
          '<div class="cart-modal__item-row">' +
            '<div class="cart-modal__qty">' +
              '<button type="button" class="cart-qty-btn minus" data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" class="cart-qty-input" data-line="' + line + '" value="' + item.quantity + '" min="1">' +
              '<button type="button" class="cart-qty-btn plus" data-line="' + line + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-modal__item-total">' + formatMoney(item.price) + ' x ' + item.quantity + ' : ' + formatMoney(item.line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-modal__remove remove-item" data-line="' + line + '">Remove</button>' +
      '</div>'
    );
  }

  function renderCartModal(cart) {
    const container = document.getElementById('cartItemsTable');
    const checkoutBtn = document.querySelector('.checkout-tb-btn');
    if (!container) return;

    container.innerHTML = cart.item_count === 0
      ? '<div class="cart-modal__empty">Your cart is empty.</div>'
      : cart.items.map(renderCartRow).join('');

    const totalEl = document.getElementById('cartTotalPrice');
    if (totalEl) totalEl.textContent = 'Total: ' + formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.style.display = cart.item_count === 0 ? 'none' : 'inline-block';

    updateCartSummary(cart);
  }

  function loadCartItems() {
    showOverlay();
    return getCart(true)
      .then(function (cart) {
        setCart(cart);
        renderCartModal(cart);
        syncRowsWithCart(cart);
      })
      .catch(function (err) { console.error(err); })
      .finally(hideOverlay);
  }

  function updateCartLine(line, quantity) {
    showOverlay();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setCart(cart);
        renderCartModal(cart);
        syncRowsWithCart(cart);
      })
      .catch(function (err) { console.error(err); })
      .finally(hideOverlay);
  }

  function initCartModal() {
    const viewCartBtn = document.getElementById('viewCartBtn');
    const closeBtn = document.getElementById('closeCartModal');
    const modal = document.getElementById('cartModal');

    if (viewCartBtn) {
      viewCartBtn.addEventListener('click', function () {
        if (modal) modal.style.display = 'flex';
        loadCartItems();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (modal) modal.style.display = 'none';
        hideOverlay();
      });
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.style.display = 'none';
          hideOverlay();
        }
      });
    }

    document.addEventListener('click', function (e) {
      const removeItemBtn = e.target.closest('.remove-item');
      if (removeItemBtn) {
        updateCartLine(parseInt(removeItemBtn.dataset.line, 10), 0);
        return;
      }

      const stepBtn = e.target.closest('.cart-qty-btn');
      if (stepBtn) {
        const line = parseInt(stepBtn.dataset.line, 10);
        const input = stepBtn.parentElement.querySelector('.cart-qty-input');
        let quantity = parseInt(input.value, 10) || 1;
        quantity = stepBtn.classList.contains('plus') ? quantity + 1 : Math.max(1, quantity - 1);
        input.value = quantity;
        updateCartLine(line, quantity);
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('.cart-qty-input')) return;
      const quantity = parseInt(e.target.value, 10);
      updateCartLine(parseInt(e.target.dataset.line, 10), (!quantity || quantity < 0) ? 0 : quantity);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initImageModal();
    initVariantSelect();
    initQuantityButtons();
    initAddToCart();
    initRemoveFromCart();
    initCartModal();

    getCart().then(function (cart) {
      syncRowsWithCart(cart);
      updateCartSummary(cart);
    });
  });
})();
